import React from "react"

type ViewMode = "cards" | "table"

interface ViewModeSelectorProps {
	viewMode: ViewMode
	onViewModeChange: (mode: ViewMode) => void
	cardsPerRow: number
	onCardsPerRowChange: (value: number) => void
	showFavoritesOnly: boolean
	onShowFavoritesOnlyChange: (value: boolean) => void
}

const ViewModeSelector: React.FC<ViewModeSelectorProps> = ({
	viewMode,
	onViewModeChange,
	cardsPerRow,
	onCardsPerRowChange,
	showFavoritesOnly,
	onShowFavoritesOnlyChange,
}) => {
	return (
		<div className="bg-white dark:bg-gray-800 p-4 rounded-lg border border-gray-200 dark:border-gray-700 mb-6">
			<div className="flex items-center justify-between mb-3">
				<h2 className="font-semibold text-gray-900 dark:text-white">View Options</h2>
				<div className="flex bg-gray-100 dark:bg-gray-700 rounded-lg p-1">
					<button
						onClick={() => onViewModeChange("cards")}
						className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
							viewMode === "cards"
								? "bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm"
								: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
						}`}>
						Cards
					</button>
					<button
						onClick={() => onViewModeChange("table")}
						className={`px-4 py-2 rounded-md text-sm font-medium transition-colors ${
							viewMode === "table"
								? "bg-white dark:bg-gray-600 text-gray-900 dark:text-white shadow-sm"
								: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
						}`}>
						Table
					</button>
				</div>
			</div>
			{viewMode === "cards" && (
				<div className="flex flex-col gap-3 pt-1">
					<div className="flex items-center gap-4">
						<span className="text-sm text-gray-600 dark:text-gray-400 whitespace-nowrap min-w-[80px]">
							Columns:{" "}
							<span className="font-semibold text-gray-900 dark:text-white">{cardsPerRow}</span>
						</span>
						<div className="flex-1 flex items-center gap-3">
							<span className="text-xs text-gray-400 dark:text-gray-500">1</span>
							<input
								type="range"
								min={1}
								max={4}
								step={1}
								value={cardsPerRow}
								onChange={(e) => onCardsPerRowChange(Number(e.target.value))}
								className="flex-1 accent-blue-600 cursor-pointer"
							/>
							<span className="text-xs text-gray-400 dark:text-gray-500">4</span>
						</div>
					</div>
					<div className="flex items-center gap-2">
						<button
							onClick={() => onShowFavoritesOnlyChange(!showFavoritesOnly)}
							className={`flex items-center gap-2 px-3 py-1.5 rounded-md text-sm font-medium transition-colors ${
								showFavoritesOnly
									? "bg-yellow-100 dark:bg-yellow-900/30 text-yellow-700 dark:text-yellow-400"
									: "text-gray-600 dark:text-gray-400 hover:text-gray-900 dark:hover:text-white"
							}`}>
							<span>{showFavoritesOnly ? "★" : "☆"}</span>
							Favorites only
						</button>
					</div>
				</div>
			)}
		</div>
	)
}

export default ViewModeSelector
